const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Founder, TechStart Nigeria",
      image: "/placeholder.svg?height=60&width=60",
      content:
        "Accurix transformed how we manage finances across our 3 companies. The multi-business feature is a game-changer!",
    },
    {
      name: "Michael Chen",
      role: "CFO, GrowthCorp",
      image: "/placeholder.svg?height=60&width=60",
      content:
        "Finally, an accounting software that doesn't require a PhD to use. Our team loves the intuitive interface.",
    },
    {
      name: "Aisha Okafor",
      role: "Small Business Owner",
      image: "/placeholder.svg?height=60&width=60",
      content:
        "The automated reports save me hours every month. I can focus on growing my business instead of spreadsheets.",
    },
  ]
  
  export default function Testimonials() {
    return (
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-4 mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">Trusted by growing businesses</h2>
            <p className="text-xl text-gray-600 dark:text-gray-400">See what our customers have to say about Accurix</p>
          </div>
  
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white dark:bg-gray-900 p-6 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
                <div className="flex items-center mb-4">
                  <img
                    src={testimonial.image || "/placeholder.svg"}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full mr-4"
                  />
                  <div>
                    <div className="font-semibold text-gray-900 dark:text-white">{testimonial.name}</div>
                    <div className="text-sm text-gray-600 dark:text-gray-400">{testimonial.role}</div>
                  </div>
                </div>
                <p className="text-gray-700 dark:text-gray-300 italic">"{testimonial.content}"</p>
                <div className="flex text-yellow-400 mt-4">{"★".repeat(5)}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  }
  